const tabs = [
  {
    id: 'top',
    name: 'トップ'
  },
  {
    id: 'delivery-request-list',
    name: '納品依頼一覧'
  },
  {
    id: 'delivery-request-registration',
    name: '納品依頼登録'
  },
  {
    id: 'expense-detail-actual-shipment',
    name: '費用明細（出荷実績）'
  },
  {
    id: 'expense-detail-storage-fee',
    name: '費用明細（保管料等）'
  },
  {
    id: 'receive-amount-diff-setting',
    name: '受取金額差額設定'
  }
]

export default tabs



// WEBPACK FOOTER //
// ./src/common/delivery-tabs.js